export default __webpack_public_path__ + "static/media/single.a7ecdabb.svg";